import React from 'react';
import { Link } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { StyledSkipToMainContentPaper } from './SkipToMainContent.styled';

export default function SkipToMainContent() {
  return (
    <StyledSkipToMainContentPaper>
      <Link variant="p" href="#main_content">
        <FormattedMessage id="a11y.skip_to_main_content" />
      </Link>
    </StyledSkipToMainContentPaper>
  );
}
